import React from "react";

import { Row, Layout, Button } from "antd";
import Graph from "./Graph";
import Filter from "./Filter";
import InputFilter from "./InputFilter";
import BooleanFilter from "./BooleanFilter";
import { partial } from "lodash";

const { Content, Sider } = Layout;

export default function AwardedProviderGraph(props) {
  const [filters, setFilters] = React.useState({ year: [new Date().getFullYear() - 1] });
  const [renderFlag, setRenderFlag] = React.useState(false);
  const api = `${props.url}/awarded_graph`;

  function onFilterChange(key, values) {
    let result = { ...filters };
    result[key] = [].concat(values);
    setFilters(result);
  }

  function onRender() {
    setRenderFlag(!renderFlag);
  }
  return (
    <Layout>
      <Sider width={250}>
        <Row style={{ marginTop: "20px" }}>
          <Filter
            placeholder="Año"
            api={api}
            source="years"
            onChange={partial(onFilterChange, "year")}
            defaultValue={[new Date().getFullYear() - 1]}
          ></Filter>
        </Row>
        <Row style={{ marginTop: "20px" }}>
          <Filter
            placeholder="Entidad"
            api={api}
            source="entities"
            onChange={partial(onFilterChange, "entity")}
          ></Filter>
        </Row>

        <Row style={{ marginTop: "20px" }}>
          <Filter
            placeholder="Modalidad"
            api={api}
            source="procurement_types"
            onChange={partial(onFilterChange, "procurement_type")}
          ></Filter>
        </Row>

        <Row style={{ marginTop: "20px" }}>
          <Filter
            placeholder="Categoría"
            api={api}
            source="categories"
            onChange={partial(onFilterChange, "category")}
          ></Filter>
        </Row>

        <Row style={{ marginTop: "20px" }}>
          <Filter
            placeholder="Objeto de Llamado"
            api={api}
            source="procurement_objects"
            onChange={partial(onFilterChange, "procurement_object")}
          ></Filter>
        </Row>

        <Row style={{ marginTop: "20px" }}>
          <InputFilter
            placeholder="RUC (sin DV)"
            onChange={partial(onFilterChange, "ruc")}
          ></InputFilter>
        </Row>
        <Row style={{ marginTop: "20px" }}>
          <InputFilter
            placeholder="Razón social"
            onChange={partial(onFilterChange, "provider")}
          ></InputFilter>
        </Row>
        <Row style={{ marginTop: "20px" }}>
          <BooleanFilter
            checkedChildren="solo COVID19"
            unCheckedChildren="todas las adjudicaciones"
            onChange={partial(onFilterChange, "covid19")}
          ></BooleanFilter>
        </Row>

        <Row style={{ marginTop: "20px" }}>
          <Button type="primary" style={{ width: "90%" }} onClick={onRender}>
            Dibujar
          </Button>
        </Row>
      </Sider>
      <Content>
        <Graph
          api={api}
          filters={filters}
          show={renderFlag}
          onRender={onRender}
          linkWidth={(w) => Math.log(w) + 1}
        ></Graph>
      </Content>
    </Layout>
  );
}
